<app-modal-header [title]="title" (closeModal)="closeModal()"></app-modal-header>

<div class="p-4">
  <form (ngSubmit)="submitForm(form.value)" [formGroup]="form" autocomplete="off" novalidate>
    <div class="grid grid-cols-12">
      <div class="col-span-12 grid grid-cols-12 md:gap-4">
        <div class="col-span-12">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Name</mat-label>
            <input matInput formControlName="roleName" />
            <mat-error>
            <span *ngIf="!form.get('roleName').valid && !form.get('roleName').untouched">
              {{ 'This field is required' }}
            </span>
            </mat-error>
          </mat-form-field>
        </div>
       
<!--        <div class="col-span-12">-->
<!--          <mat-form-field appearance="outline" class="w-full">-->
<!--            <mat-label>Description</mat-label>-->
<!--            <input matInput formControlName="roleDescription" />-->
<!--            <mat-error>-->
<!--            <span *ngIf="!form.get('roleDescription').valid && !form.get('roleDescription').untouched">-->
<!--              {{ 'This field is required' }}-->
<!--            </span>-->
<!--            </mat-error>-->
<!--          </mat-form-field>-->
<!--        </div>-->
<!--        <div class="col-span-12">-->
<!--          <mat-form-field appearance="outline" class="w-full">-->
<!--            <mat-label>Description</mat-label>-->
<!--            <input matInput formControlName="roleDescription" />-->
<!--            <mat-error>-->
<!--            <span *ngIf="!form.get('roleDescription').valid && !form.get('roleDescription').untouched">-->
<!--              {{ 'This field is required' }}-->
<!--            </span>-->
<!--            </mat-error>-->
<!--          </mat-form-field>-->
<!--        </div>-->
      </div>

    </div>
    <div class="col-span-12">
      <app-save-area
        saveText="Save"
        [saveIcon]="'save'"
        [showCancel]="false"
        [confirmFirst]="true"
        (save)="submitForm(form.value)"
        [savingData]="saveLoading"
        confirmText="This action will submit your data, confirm to continue?"
        [saveDisabled]="!form.valid"
        loadingMessage="Submitting your data..."
      ></app-save-area>
    </div>
  </form>

</div>
